<div *ngIf="mode === 'dropdown'" class="position-relative d-inline-block">
  <div
    class="mx-2 position-relative d-flex justify-content-center align-items-center cursor-pointer rounded-2 box--outer"
    (click)="toggleStyleDisplay(style)"
    (clickOutside)="style.display = 'none'"
  >
    <img src="assets/img/icon_notification.webp" width="36px" height="36px" />
    <div
      *ngIf="!!notif?.badge_counter"
      class="box--notif position-absolute rounded-circle text-center d-flex align-items-center justify-content-center p-2"
    >
      {{ auth$?.notifBadgeCounter }}
    </div>
  </div>
  <app-list
    class="dropdown-content position-absolute p-3 rounded-3"
    [ngStyle]="style"
    [notifications]="notif?.notifications"
  ></app-list>
</div>
<div
  *ngIf="mode === 'page'"
  class="mx-2 position-relative d-flex justify-content-center align-items-center cursor-pointer rounded-2 box--outer"
  [routerLink]="['/notification']"
>
  <img
    src="assets/img/icon_notification.webp"
    class="d-none d-lg-block d-xl-block d-xxl-block"
    width="36px"
    height="36px"
  />
  <img
    [src]="notifIcon"
    class="d-block d-lg-none d-xl-none d-xxl-none"
    width="36px"
    height="36px"
  />

  <div
    *ngIf="!!notif?.badge_counter"
    class="box--notif position-absolute rounded-circle text-center"
  >
    <span class="font-12">{{ notif?.badge_counter }}</span>
  </div>
</div>
